var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"survey-fill mt-page"},[(_vm.$store.state.currentUser.id)?_c('survey-form',{attrs:{"survey-id":_vm.surveyId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }